import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Leaf, ShoppingBasket, Users, Recycle } from "lucide-react";
import WordFadeIn from "./WordFadeIn";
import DrawIcon from "./DrawIcon";

const features = [
  { icon: ShoppingBasket, number: "01", title: "Regional & Saisonal", desc: "Saisonales Obst und Gemüse sowie Erzeugnisse aus der Region." },
  { icon: Leaf, number: "02", title: "Bio & Vegan", desc: "Bioware und vegane bzw. laktosefreie Alternativen bei Joghurt, Milchdrinks, Käse und Quark." },
  { icon: Users, number: "03", title: "Familiäre Atmosphäre", desc: "Peter Kotlarski, seine Familie und ein 26-köpfiges Team stehen für persönliches Miteinander." },
  { icon: Recycle, number: "04", title: "Generationsfreundlich", desc: "Barrierefreier Markt und bis 2027 als „Generationsfreundlich“ zertifiziert." },
];

const FrischeSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="frische" ref={ref} className="relative py-20 md:py-32 px-6 md:px-16 bg-secondary/30" aria-label="Frische und Qualität">
      <div className="max-w-7xl mx-auto">
        {/* Decorative drawn leaf icon */}
        <DrawIcon
          variant="leaf"
          size={140}
          delay={0.2}
          className="absolute right-8 md:right-20 top-16 z-10 opacity-20 hidden sm:block"
        />

        <div className="mb-16 md:mb-20 text-center md:text-left">
          <p className="font-body text-sm text-primary-bright tracking-[0.3em] uppercase mb-4">
            Frische & Qualität
          </p>
          <WordFadeIn
            text="Was uns auszeichnet"
            as="h2"
            className="font-display text-3xl sm:text-4xl md:text-6xl font-bold text-foreground leading-tight max-w-3xl mx-auto md:mx-0 [hyphens:none]"
            staggerDelay={0.12}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 border-t border-border">
          {features.map((f, i) => (
            <motion.div
              key={f.number}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.15 }}
              className="border-b border-border p-6 md:p-12 group hover:bg-secondary/50 transition-colors duration-500 sm:odd:border-r flex flex-col items-center text-center md:flex-row md:items-start md:text-left gap-4 md:gap-6"
            >
              <f.icon className="w-7 h-7 text-primary-bright shrink-0" aria-hidden="true" />
              <div>
                <span className="font-display text-sm text-primary-bright tracking-wider">
                  {f.number}
                </span>
                <h3 className="mt-2 font-display text-xl md:text-2xl font-semibold text-foreground [hyphens:none]">
                  {f.title}
                </h3>
                <p className="mt-2 text-muted-foreground font-body leading-relaxed">
                  {f.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FrischeSection;